<!--
 * @Author: your name
 * @Date: 2021-09-03 13:14:55
 * @LastEditTime: 2021-11-15 14:15:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/combinationCourse/components/toStudy.vue
-->
<!--  -->
<template>
  <div class="study">
    <div class="left">
      <div @click="openChat">
        <img src="@/assets/img/productDetail/icon_custom.png" alt />
        <span>咨询</span>
      </div>
      <!-- 购物车 点击进入购物车列表页-->
      <div class="carIconBtn" @click="goShoppingCar" v-if="!this.$root.miniprogram">
        <img src="../../../assets/img/productDetail/carIcon.png" alt />
        <i class="carNum" v-if="cartCount">{{cartCount}}</i>
        <span>购物车</span>
      </div>
    </div>

    <button class="to-study" :class="[{mini:this.$root.miniprogram}]" @click="study">去学习</button>
  </div>
</template>
<script>
import { setTokenFromCookie, gioEnterCart } from '@/utils/tools';
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';

export default {
  props: {
    cartCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {},

  methods: {
    study() {
      if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({ url: '/myCourse/courseList/index' });
        return;
      }
      if (this.$root.$data.isApp) {
        this.$sendToApp('goLearnCenterPage', {}, false);
      } else {
        this.$router.push({ path: '/personalCenter/mycourseList' });
      }
    },
    openChat() {
      if (this.$root.$data.isApp) {
        // this.$sendToApp(
        //   'openNewWebView',
        //   {
        //     url: 'https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=6194a29668991d6b4e202137',
        //   },
        //   false,
        // );
        return;
      }
      // window.open(
      //   'https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=6194a29668991d6b4e202137',
      // );
    },
    // 查看购物车列表
    goShoppingCar() {
      if (!this.userInfo.id) {
        const { isApp = false } = this.$root.$data;
        if (isApp) {
          this.$sendToApp('login', {}, true).then(async () => {
            setTokenFromCookie();
            await this.$root.getUserInfo();
            await this.$parent.getPageDetail();
          });
        } else {
          this.$router.push({
            path: '/registrationLogin',
            query: { redirect: '/shoppingCar', beforePageName: 1 },
          });
          gioEnterCart(1);
        }
        return;
      }
      this.$router.push({
        path: '/shoppingCar',
        query: {
          beforePageName: 1,
        },
      });
      gioEnterCart(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.study {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 40px;
  background: #fff;
  .left {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    > div {
      padding-right: 30px;
      img {
        display: block;
        width: 48px;
        height: 48px;
      }
      span {
        display: block;
        color: #333;
        font-weight: 400;
        font-size: 20px;
      }
    }
  }
  button.to-study {
    width: 260px;
    height: 90px;
    color: #fff;
    font-weight: 500;
    font-size: 32px;
    line-height: 44px;
    background: #ff6c02;
    border-radius: 45px;
  }
  button.to-study.mini{
    width: 400px;
  }
}
.carIconBtn {
  position: relative;
  img {
    display: block;
    width: 44px;
    height: 44px;
    margin: 0 auto;
  }
  span {
    display: block;
    color: #333;
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
  }
  .carNum {
    position: absolute;
    top: -10px;
    right: 28px;
    display: block;
    width: 30px;
    height: 30px;
    color: #fff;
    font-weight: 500;
    font-size: 18px;
    font-style: normal;
    line-height: 30px;
    text-align: center;
    background: #ff472d;
    border: 2px solid #fff;
    border-radius: 50%;
  }
}
</style>
